import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import QRCode from 'qrcode';
import moment from "moment";
import config from './utils/config';
import Redirect from './utils/Redirect';
import get_token from '@/utils/get_token';
import get_accountInfo from '@/utils/get_accountInfo';
import get_userInfo from '@/utils/get_userInfo';
import PageRecord from "@/utils/PageRecord";
import VueClipboard from 'vue-clipboard2';
import _ from 'lodash';

Vue.use(VueClipboard)
Vue.config.productionTip = false;

PageRecord.init() // 页面埋点 初始化

router.beforeEach((to, from, next) => {

  // 特殊页面处理
  // if(config.WebOS!=='wx' ){
  if(config.WebOS!=='wx' && window.location.hostname!='localhost' && window.location.hostname!='1688new.xingyebao.com'){
    // 特殊页面特殊情况下重定向
    if(Redirect(to, from)){
      return false; // 使用false不使用next(false)因为next会走进下一次路由导致逻辑错误
    }
  }

  // 记录埋点 页面停留时间
  if( to.name != from.name ){
    // 将 to.name 发给后端
    PageRecord.post_record({page_name: from.name , now_page:to.name})
  }

  window.PATH_RECORD= to.name
  /* 路由发生变化修改页面title */
  if(to.params.title){
    document.title = to.params.title
  }else if(to.query.title){
    document.title = to.query.title
  }else{
    document.title = to.meta.title
  }
  // 修改tabbar选中样式
  let TabbarData = store.state.Public.TabbarMap
  for(let i in TabbarData){
    if( TabbarData[i].path == to.name ){
      store.commit("Public/SwitchTabbarActive", i)
    }
  }

  setTimeout(()=>{
    if(to.meta.is_APP){
      document.getElementById("app").classList.add("is_APP")        
    }else{
      document.getElementById("app").classList.remove("is_APP")
    }
  })
  
  let data = {
    page_from: from.name||'main_page',
    page_name: to.name,
    page_time:'0.00',
    receiver_id: '',
    page_param:{remarks:'进入页面埋点'},
  }
  store.dispatch('Public/inH5Record', data)
  next()
})

const Tools = { // 统一注入工具，需要什么将工具添加其到对象中即可
  _,
  moment,
  config,
  qrcode: QRCode,
  OSS: process.env.VUE_APP_OSSBaseUrl,
  OSSBaseUrl: process.env.VUE_APP_OSSBaseUrl,
} 
Vue.prototype._ = _
for (let i in Tools) {
  Vue.prototype['$' + i] = Tools[i]
}

async function get_info(){
  // 主消息id
  let sms_code = new URLSearchParams(window.location.search).get('sms_code')||'';
  sessionStorage.setItem('sms_code', sms_code);
  // 店铺id
  let v_id = new URLSearchParams(window.location.search).get('v_id')||'';
  sessionStorage.setItem('v_id', v_id);
  
  // 访问来源
  let source = new URLSearchParams(window.location.search).get('source')||'';
  localStorage.setItem('source', source);
  // 表名优惠券领取来源 
  let lq_source = new URLSearchParams(window.location.search).get('lq_source')||'';
  sessionStorage.setItem('lq_source', lq_source);
  // 接收人id
  let r_id = new URLSearchParams(window.location.search).get('r_id')||'';
  sessionStorage.setItem('r_id', r_id);
  // 分表表名时间
  let date_time = new URLSearchParams(window.location.search).get('date_time')||'';
  sessionStorage.setItem('date_time', date_time);
  // 分表表名时间
  let last_time = new URLSearchParams(window.location.search).get('last_time')||'';
  sessionStorage.setItem('last_time', last_time);
  // 区分是否是子账号
  let is_sub = new URLSearchParams(window.location.search).get('is_sub')||'';
  sessionStorage.setItem('is_sub', is_sub);
  // 获取完整get参数
  let all_param = window.location.search.substring(1)
  sessionStorage.setItem('all_param', all_param);
  
  // 判断是否需要分表
  let r_sub = new URLSearchParams(window.location.search).get('r_sub')||'';
  sessionStorage.setItem('r_sub', r_sub);

  // 获取token
  if(config.WebOS == 'wx'){ // 微信环境下才获取token
    let token = sessionStorage.getItem('x-token');
    if(!token || token=='null' || token=='undefined' ){ // 如果没有token则获取授权并换取token
      let token = await get_token()
      if(!token){
        return false
      }
    }
  }else{
    sessionStorage.removeItem('x-token');
  }
  // 没有获取用户信息
  if( Object.keys(store.state.Public.UserInfo).length <= 0 ){
    await get_userInfo()
  }
  // 没有缺省页信息
  if( Object.keys(store.state.Public.AccountInfo).length <= 0 ){
    await get_accountInfo()
  }
  
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount("#app");
}
get_info()
